<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Table of Contents</p>
<p class="P_TOC_Entry_1"><a href="#/section0002#auto_bookmark_table_of_contents_1">Blurb</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_table_of_contents_1">Dedication</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0004#auto_bookmark_table_of_contents_1">Illuminate the Goal</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0005#auto_bookmark_table_of_contents_1">First Kickoff</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0006#auto_bookmark_table_of_contents_1">Mornings After</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0007#auto_bookmark_table_of_contents_1">Naked Limbs and Fallen Leaves</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0008#auto_bookmark_table_of_contents_1">Stormy Night</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0009#auto_bookmark_table_of_contents_1">Sorta Thankful</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0010#auto_bookmark_table_of_contents_1">Winning and Losing</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0011#auto_bookmark_table_of_contents_1">Thankful</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0012#auto_bookmark_table_of_contents_1">Fore!</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0013#auto_bookmark_table_of_contents_1">Castles in the Sky</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0014#auto_bookmark_table_of_contents_1">A Gateway Drug to Christmas</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0015#auto_bookmark_table_of_contents_1">And to All a Good Sports Night</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0016#auto_bookmark_table_of_contents_1">Readers love Amy Lane</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0017#auto_bookmark_table_of_contents_1">About the Author</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0018#auto_bookmark_table_of_contents_1">By Amy Lane</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0019">Visit Dreamspinner Press</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0020#auto_bookmark_toc_2">Copyright Page</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?4e34091c